"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import getProposalForm from "./utils/get_proposal_form";
import locateCoordinates from "./utils/locate_coordinates";
import getCurrentPosition from "./utils/get_current_position";
import { isLoading, setLoading } from "./utils/loading";
const findMyLocationHandler = function(e) {
  return __async(this, null, function* () {
    e.preventDefault();
    const $button = $(this);
    if (isLoading($button)) {
      return;
    }
    const $addressInputField = $button.closest(".input-group").find(".input-group-field");
    setLoading([$button, $addressInputField], true);
    let coordinates = null;
    try {
      let { coords } = yield getCurrentPosition();
      const address = yield locateCoordinates(coords);
      $addressInputField.val((address == null ? void 0 : address.toString()) || "");
      coordinates = [coords.latitude, coords.longitude];
      $addressInputField.trigger("geocoder-suggest-coordinates.decidim", [
        coordinates
      ]);
    } finally {
      setLoading([$button, $addressInputField], false);
    }
    setTimeout(() => {
      console.log("coordinates", coordinates);
      if (!coordinates) {
        return;
      }
      const $map = $("#address_map");
      if ($map.length > 0) {
        $map.trigger("decidim.voca.refresh_map", {
          marker: { latitude: coordinates[0], longitude: coordinates[1] }
        });
      }
    }, 64);
  });
};
document.addEventListener("DOMContentLoaded", () => {
  const $form = getProposalForm();
  if (!$form) return;
  const $useMyLocationButton = $form.find(".js--use_my_location");
  if (!$useMyLocationButton) {
    return;
  }
  $useMyLocationButton.on("click", findMyLocationHandler);
});
